export default __webpack_public_path__ + "static/media/Eina02-Bold.f8011405.ttf";